module.exports = __webpack_public_path__ + "static/media/visaLogo.b1684820.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/patient-list/images/visaLogo.svg
// module id = 13468
// module chunks = 0